import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';

var toastCacheMap = {};
/**
 * toast的缓存策略，做一个简单的管理，防止多个相同的toast一直创建叠加，如果有相同的text，不做任何处理
 */

function cacheToaster(obj, method) {
  var originMethod = obj[method];

  obj[method] = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      text: ''
    };

    if (!toastCacheMap[method]) {
      toastCacheMap[method] = {};
    }

    if (!toastCacheMap[method][props.text]) {
      toastCacheMap[method][props.text] = true;
      return originMethod(_objectSpread2(_objectSpread2({}, props), {}, {
        onCancel: function onCancel() {
          var _props$onCancel;

          toastCacheMap[method][props.text] = false;
          (_props$onCancel = props.onCancel) === null || _props$onCancel === void 0 ? void 0 : _props$onCancel.call(props);
        }
      }));
    }
  };
}

export { cacheToaster };
//# sourceMappingURL=cache.js.map
